import React, {FC} from 'react';
import './style.scss';
import mixerLogo from './../../assets/img/intro/intro__mixer.png';
import BaseButton from "../form/Button";
import {useHistory} from 'react-router-dom';
import classNames from "classnames";
import {IS_PLATFORM_IOS} from "../../services/utils/platforms";

interface IMixer {
    getRecommendedMixes: any
}

const Mixer: FC<IMixer> = ({getRecommendedMixes}) => {
    const history = useHistory();

    const randomMixHandler = () => {
        getRecommendedMixes();
        history.push("/mixer/random-mix");
    };


    return (
        <div className={classNames({
            "mixer": true,
            "mixer--ios": IS_PLATFORM_IOS
        })}>
            <div className="mixer__container">
                <img
                    className="mixer__logo"
                    src={mixerLogo}
                    alt=""
                />
                <div className="mixer__title">
                    Выберите свои предпочтения, а мы подберем подходящий для Вас микс вкусов!
                </div>
                <div  className="mixer__main-buttons">
                    <BaseButton
                        isGreenButton
                        isFullWidth
                        sizePadding="10px 0"
                        sizeBorderRadius={20}
                        onClick={() =>  history.push("/mixer/brands")}
                    >
                    <span  className="mixer__main-buttons-text">
                        Перейти в каталог
                    </span>
                    </BaseButton>
                </div>
                <div className="mixer__main-buttons">
                    <BaseButton
                        isRedButton
                        isFullWidth
                        sizePadding="10px 0"
                        sizeBorderRadius={20}
                        onClick={() => history.push("/mixer/preferences/tastes")}
                    >
                         <span className="mixer__main-buttons-text">
                        Выбрать по предпочтениям
                    </span>
                    </BaseButton>
                </div>
                <div className="mixer__random-mix-container">
                   <span
                       className="mixer__random-mix-button"
                       onClick={randomMixHandler}
                   >
                       Случайный микс
                   </span>
                </div>
            </div>
        </div>
    )
};

export default Mixer;
